import AddressForm from "./address_form.js";
import CountryPhonePlugin from "../ui/country_phone_plugin.js";
import Route from '../route.js';
import moment from "moment";

$(function () {
    if (Route === ("account-complete")) {
        const formId = "complete-registration-form";
        const tradeTypes = [
            "Trade",
            "Wine Investment Company",
            "Institutional Investments",
            "Wine Fund",
            "Non Wine",
            "Automated account",
            "HRC Hotel,Rest/Club",
        ];

        // account purpose select2
        const $accountPurposeSelect = $("select[name='accountPurpose[]']")
            .select2({
                placeholder: "Please Select",
                allowClear: true,
                closeOnSelect: false,
                multiple: true,
                selectionCssClass: 'lighter-grape-border',
            });
        
        // date of birth
        $("input[name='dateOfBirth']").flatpickr({
            enableTime: false,
            dateFormat: 'd/m/Y',
            allowInput: true,
            maxDate: moment().subtract(18, 'years').toDate(),
            disableMobile: true
        });

        // account type
        $("select[name='accountType']").on("change", function () {

            const type = $(this).val();
            const isTradeType = tradeTypes.includes(type);
            const isPrivateType = (type === "Private");

            if (isTradeType) {
                $("#companyNameContainer").removeClass("d-none");
                $("#taxRegistrationNumberContainer").removeClass("hidden")
                $("#howDidYouHearAboutUsContainer").addClass('d-none');
                $("#dateOfBirthContainer").addClass('d-none');
            } else {
                $("#companyNameContainer").addClass("d-none");
                $("#taxRegistrationNumberContainer").addClass("hidden");
                $("#dateOfBirthContainer").removeClass('d-none');
                $("#howDidYouHearAboutUsContainer").removeClass('d-none');
            }

            // enable and set account purpose data
            $accountPurposeSelect.val(null).trigger("change");
            $accountPurposeSelect.empty();
            if (type) {
                for (const accountDetailType of registrationFormStaticData["accountDetailTypes"]) {
                    const shouldAdd = (isTradeType && (accountDetailType.type === "TRADE" || accountDetailType.type === "ON-TRADE"))
                        || (isPrivateType && accountDetailType.type === "PRIVATE")
                        || (!isTradeType && !isPrivateType); // neither Trade/Private => show all options
                    if (shouldAdd) {
                        const option = new Option(accountDetailType.name, accountDetailType.name);
                        $accountPurposeSelect.append(option);
                    }
                }
                $accountPurposeSelect.prop("disabled", false);
            } else {
                $accountPurposeSelect.prop("disabled", true);
            }
        });
        $("select[name='accountType']").trigger("change", { doNotHighlightInvalidFields: true });

        const CompleteRegistrationForm = new AddressForm({
            form_id: `#${formId}`,
        });
        CompleteRegistrationForm.addSubmitListener((response) => {
            if (response.success) {
                window.location.href = response.data.return_url;
            } else {
                $('#accountRegistrationFailedModal').modal('show');
                $("#accountRegistrationFailedModal").on('hidden.bs.modal', function (e) {
                    window.location.href = "/";
                });
            }
        }, () => {
            $(`#${formId} input[name='endTimestamp']`).val(Date.now());
            return true;
        });

        // country
        const countryPhonePlugin = new CountryPhonePlugin("input[name='phoneNumberSmall']");

        $('select[name="countryCode"]').on("change", function () {
            const $selectedOption = $("option:selected", $(this));
            const countryCode = $(this).val();
            const isEU = $selectedOption.data("iseu") === "yes";

            $('input[name="countryName"]').val($selectedOption.data("name"));

            if (!$(`#${formId} input[name='phoneNumberSmall']`).prop('disabled')) {
                if(countryCode === 'JA'){
                    countryPhonePlugin.setCountry('JP')
                }else{
                    countryPhonePlugin.setCountry(countryCode);
                }
            }

            $(".find_address_btn").addClass("hidden");
            const $addressSelect = $(".add_lookuplist");
            $addressSelect.addClass("hidden");
            $addressSelect.next('.select-styled').hide();
        
            populateCurrency(countryCode, isEU);
        });

        // how did you hear about us
        $(document).on("change", 'select[name="howDidYouHear"]', function() {
            const $select = $(this);
            const $selectedOption = $("option:selected", $(this));
            const isFreeTextAnswer = ($selectedOption.data("isfreetextanswer") === "yes");
            const freeTextLabel = $selectedOption.data("freetextlabel");
            const mapping = $selectedOption.data("mapping");

            $('input[name="howDidYouHearMapping"]').val(mapping);
            if (isFreeTextAnswer) {
                $('input[name="howDidYouHearFreeText"]')
                    .prop("placeholder", `Enter ${freeTextLabel}`)
                    .parent()
                    .removeClass("d-none")
                $select.parent().addClass("d-none");
            } else {
                $('input[name="howDidYouHearFreeText"]')
                    .parent()
                    .addClass("d-none");
            }
        });

        // important date type select
        $(document).on("change", 'select[name="importantDateType[]"]', function() {
            const $select = $(this);
            const $selectedOption = $("option:selected", $(this));
            const isFreeTextAnswer = ($selectedOption.data("isfreetextanswer") === "yes");
            const freeTextLabel = $selectedOption.data("freetextlabel");
            const $freeTextInput = $select.closest(".important-date-type-container")
                .find("input[name='importantDateTypeFreeText[]']");

            if (isFreeTextAnswer) {
                $freeTextInput
                    .prop("placeholder", `Enter ${freeTextLabel}`)
                    .parent()
                    .removeClass("d-none")
                $select.parent().addClass("d-none");
            } else {
                $freeTextInput
                    .parent()
                    .addClass("d-none");
            }
        });

        // add/remove important date blocks
        $("button.add-important-date-btn").on("click", function() {
            addImportantDateBlock();
            return false;
        });
        $(document).on('click', 'button.remove-important-date-btn', function(e){
            const blockId = $(e.currentTarget).data('blockid');
            $(`.important-date-block.block-${blockId}`).remove();
            return false;
        });

        // event handler for select-free-text-companion
        $(document).on("click", "i.custom-select-free-text-companion-close-btn", function(e) {
            const $btn = $(this);
            const $select = $btn.parent().parent().find('select');

            // hide and clear free text
            $btn.prev().val("");
            $btn.parent().addClass("d-none");

            // show and clear select
            $select.val("");
            $select.parent().removeClass("d-none");
            $select.setDisplayText($select.data("title") || "Please Select");
            $select.trigger("change");
        });

        // attach event handlers for validation
        $(document).on("input change", `#${formId} input`, function(e, params) {
            const doNotHighlightInvalidFields = isObject(params) && (params.doNotHighlightInvalidFields || params.countryPhonePluginAutoTrigger);
            validateForm(doNotHighlightInvalidFields);
        });
        $(document).on("change", `#${formId} select`, function(e, params) {
            const doNotHighlightInvalidFields = isObject(params) && (params.doNotHighlightInvalidFields || params.countryPhonePluginAutoTrigger);
            validateForm(doNotHighlightInvalidFields);
        });

        function validateForm(doNotHighlightInvalidFields) {
            const mandatoryFieldsValid = validateMandatoryFields(doNotHighlightInvalidFields);
            const conditionalFieldsValid = validateConditionalFields(doNotHighlightInvalidFields);
            const isFormValid = mandatoryFieldsValid && conditionalFieldsValid;

            $(`#${formId} button[type="submit"]`).prop("disabled", !isFormValid);
        }

        function validateMandatoryFields(doNotHighlightInvalidFields) {
            const mandatoryFields = [{
                name: "accountType",
                type: "select",
                registrationOnly: true,
            },{
                name: "salutation",
                type: "select",
                registrationOnly: true,
            },{
                name: "firstName",
                type: "input",
                registrationOnly: true,
            },{
                name: "lastName",
                type: "input",
                registrationOnly: true,
            },{
                name: "email",
                type: "input"
            },{
                name: "countryCode",
                type: "select",
                registrationOnly: true,
            },{
                name: "currencyCode",
                type: "select",
                registrationOnly: true,
            },{
                name: "phoneNumberSmall",
                type: "input",
                registrationOnly: true,
            },{
                name: "postalCode",
                type: "input",
                registrationOnly: true,
            },{
                name: "addressLine1",
                type: "input",
                registrationOnly: true,
            },{
                name: "city",
                type: "input",
                registrationOnly: true,
            },{
                name: "county",
                type: "input",
                registrationOnly: true,
            }];

            let isValid = true;
            for (const mandatoryField of mandatoryFields) {
                if (!mandatoryField.registrationOnly) {
                    const $field = $(`#${formId} ${mandatoryField.type}[name="${mandatoryField.name}"]`);
                    if (!$field.val() || (Array.isArray($field.val()) && $field.val().length === 0)) {
                        if (!doNotHighlightInvalidFields) {
                            changeFieldValidity($field, false);
                        }
                        isValid = false;
                    } else {
                        changeFieldValidity($field, true);
                    }
                }
            }

            return isValid;
        }

        function validateConditionalFields(doNotHighlightInvalidFields) {
            let isValid = true;

            // trade/private mandatory fields
            if (isTradeAccountType()) {
                // company name
                const $companyName = $('input[name="companyName"]');
                if (!$companyName.val()) {
                    isValid = false;
                    if (!doNotHighlightInvalidFields) {
                        changeFieldValidity($companyName, false);
                    }
                } else {
                    changeFieldValidity($companyName, true);
                }
            } else {
                const mandatoryFields = [{
                    name: "dateOfBirth",
                    type: "input"
                }, {
                    name: "howDidYouHear",
                    type: "select"
                }];
                for (const mandatoryField of mandatoryFields) {
                    const $field = $(`#${formId} ${mandatoryField.type}[name="${mandatoryField.name}"]`);
                    if (!$field.val() || (Array.isArray($field.val()) && $field.val().length === 0)) {
                        if (!doNotHighlightInvalidFields) {
                            changeFieldValidity($field, false);
                        }
                        isValid = false;
                    } else {
                        changeFieldValidity($field, true);
                    }
                }
            }

            return isValid;
        }

        function isTradeAccountType() {
            const $accountTypeSelect = $('select[name="accountType"]');
            return tradeTypes.includes($accountTypeSelect.val());
        }

        function isObject(val) {
            return val && val.constructor === Object;
        }

        function changeFieldValidity($field, isValid) {
            const errorClass = "input-required";

            if ($field.is("input")) {
                !isValid ? $field.addClass(errorClass) : $field.removeClass(errorClass);
            } else if ($field.is("select") && $field.hasClass("select_custom")) {
                const $elementToHighlight = $field.parent(".select").find(".select-styled");
                !isValid ? $elementToHighlight.addClass(errorClass) : $elementToHighlight.removeClass(errorClass);
            } else if ($field.is("select") && $field.hasClass("select2-hidden-accessible")) {
                const $elementToHighlight = $field.parent().find(".select2-selection--multiple");
                !isValid ? $elementToHighlight.addClass(errorClass) : $elementToHighlight.removeClass(errorClass);
            }
        }

        function populateCurrency(countryCode, isEU) {
            const countryCodeToCurrencyCodeMap = {
                'GB': 'GBP',
                'CH': 'CHF',
                'JA': 'JPY',
                'JP': 'JPY',
                'SG': 'SGD',
                'HK': 'HKD',
                'US': 'USD',
            };

            const $currencySelect = $(`#${formId} select[name='currencyCode']`);
            let newCurrencyCode = null;
            if (countryCodeToCurrencyCodeMap[countryCode]) {
                newCurrencyCode = countryCodeToCurrencyCodeMap[countryCode];
            } else if (isEU) {
                newCurrencyCode = "EUR";
            } else {
                newCurrencyCode = "GBP";
            }

            if (newCurrencyCode) {
                $currencySelect.val(newCurrencyCode).trigger("change");
                $currencySelect.updateVal(newCurrencyCode);
            }
        }

        // start timestamp
        $(`#${formId} input[name='startTimestamp']`).val(Date.now());
    }
});

